import React from "react";

const Lines = () => {
  return (
    <React.Fragment>
      <svg
        width="1280"
        height="3452"
        viewBox="0 0 1280 3452"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M957 165.5H858.75C852.537 165.5 847.5 170.537 847.5 176.75V176.75C847.5 182.963 842.463 188 836.25 188H738"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M465.5 318V212C465.5 198.745 476.245 188 489.5 188H543"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M323 255.5H409C422.255 255.5 433 244.755 433 231.5V212C433 198.745 443.745 188 457 188H543"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M813.5 318V212C813.5 198.745 802.755 188 789.5 188H738"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M927 2761.5H933C946.255 2761.5 957 2772.25 957 2785.5V3051.5C957 3064.75 967.745 3075.5 981 3075.5H993"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M738 2831H824C837.255 2831 848 2820.25 848 2807V2786"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M927 2761.5H933C946.255 2761.5 957 2772.25 957 2785.5V2876.5C957 2889.75 967.745 2900.5 981 2900.5H993"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M543 2831H474C460.745 2831 450 2841.75 450 2855V2877"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M371 2901H323"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M371 2901H366C352.745 2901 342 2911.75 342 2925V3056.5C342 3066.99 333.493 3075.5 323 3075.5V3075.5"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M450 2925V2936.75C450 2949.59 460.409 2960 473.25 2960V2960C486.091 2960 496.5 2970.41 496.5 2983.25V2995"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M927 2761.5H942C951.941 2761.5 960 2753.44 960 2743.5V2743.5C960 2733.56 968.059 2725.5 978 2725.5H993"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M371 2901H364C350.745 2901 340 2890.25 340 2877V2742.5C340 2733.11 332.389 2725.5 323 2725.5V2725.5"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M441 2171V2197"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M543 2147H521"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M543 2147V2147C535.82 2147 530 2141.18 530 2134V2077C530 2072.03 525.971 2068 521 2068V2068"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M738 2147H916C929.255 2147 940 2157.75 940 2171V2448.5C940 2461.75 929.255 2472.5 916 2472.5H911"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M738 2147H938C951.255 2147 962 2157.75 962 2171V2181.5C962 2194.75 972.745 2205.5 986 2205.5H993"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M543 2147V2147C536.373 2147 531 2152.37 531 2159V2322C531 2335.25 520.255 2346 507 2346H477.5C464.245 2346 453.5 2356.75 453.5 2370V2392"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M738 2147H916C929.255 2147 940 2136.25 940 2123V2007.5C940 1994.25 950.745 1983.5 964 1983.5H993"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M361 2147H356C342.745 2147 332 2136.25 332 2123V2052.5C332 2039.25 321.255 2028.5 308 2028.5H287"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M361 2147H333C319.745 2147 309 2157.75 309 2171V2251.5C309 2263.65 299.15 2273.5 287 2273.5V2273.5"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M361 2147H357C343.745 2147 333 2157.75 333 2171V2448.5C333 2461.75 322.255 2472.5 309 2472.5H287"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M738 2147H916C929.255 2147 940 2157.75 940 2171V2426C940 2439.25 950.745 2450 964 2450H993"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M738 2147V2147C743.523 2147 748 2142.52 748 2137V2080C748 2073.37 753.373 2068 760 2068V2068"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M640 220V755.72"
          stroke="#CED4DA"
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray="1 6"
        />
        <path
          d="M640 819V1344.76"
          stroke="#CED4DA"
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray="1 6"
        />
        <path
          d="M640 1406.76V1490.5C640 1507.07 653.431 1520.5 670 1520.5H784C806.091 1520.5 824 1538.41 824 1560.5V1956C824 1972.57 810.569 1986 794 1986H670C653.431 1986 640 1999.43 640 2016V2117"
          stroke="#CED4DA"
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray="1 6"
        />
        <path
          d="M640 2178V2799.36"
          stroke="#CED4DA"
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray="1 6"
        />
        <path
          d="M738 1376H893C906.255 1376 917 1386.75 917 1400V1622C917 1635.25 927.745 1646 941 1646H1006"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M738 1376H893C906.255 1376 917 1386.75 917 1400V1676C917 1689.25 927.745 1700 941 1700H1006"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M738 1376H893C906.255 1376 917 1386.75 917 1400V1730C917 1743.25 927.745 1754 941 1754H1006"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M957 741.5H837.75C825.186 741.5 815 751.686 815 764.25V764.25C815 776.814 804.814 787 792.25 787H738"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M957 1015H840C826.745 1015 816 1004.25 816 991V811C816 797.745 805.255 787 792 787H738"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M433 1037.5H439.999C453.254 1037.5 463.999 1026.75 463.999 1013.5V811C463.999 797.745 474.745 787 487.999 787H543"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M323 764H421.5C427.851 764 433 769.149 433 775.5V775.5C433 781.851 438.149 787 444.5 787H543"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M543 1376V1376C534.992 1376 528.5 1382.49 528.5 1390.5V1408.5C528.5 1416.51 522.008 1423 514 1423V1423"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M435 1447V1534C435 1547.25 424.255 1558 411 1558H336C322.745 1558 312 1568.75 312 1582V1661.5C312 1674.75 301.255 1685.5 288 1685.5H287"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M356 1423H334C320.745 1423 310 1412.25 310 1399V1336C310 1323.3 299.703 1313 287 1313V1313"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M356 1423H333C319.745 1423 309 1433.75 309 1447V1466C309 1478.15 299.15 1488 287 1488V1488"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M435 1447V1534C435 1547.25 445.745 1558 459 1558H665.5C678.755 1558 689.5 1568.75 689.5 1582V1695"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M435 1447V1605"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M738 1376H923C936.255 1376 947 1365.25 947 1352V1305.5C947 1297.22 953.716 1290.5 962 1290.5V1290.5"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M738 1376H923C936.255 1376 947 1386.75 947 1400V1473C947 1481.28 953.716 1488 962 1488V1488"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M543 1376V1376C535.268 1376 529 1369.73 529 1362V1276C529 1268.27 522.732 1262 515 1262V1262"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M543 1376V1376C535.268 1376 529 1369.73 529 1362V1330C529 1322.27 522.732 1316 515 1316V1316"
          stroke="#CED4DA"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      </svg>
    </React.Fragment>
  );
};

export default Lines;
